import { Behavior } from "../Behavior";
import type { IGrid } from "../types";
import type { Particle } from "../Particle";
import { Smoke } from "../particles/Smoke";

export class SpawnsSmoke extends Behavior {
    chance: number;

    constructor(chance: number = 0.05) {
        super();
        this.chance = chance;
    }

    update(particle: Particle, grid: IGrid, index: number) {
        if (Math.random() < this.chance) {
            const above = index - grid.width;
            if (grid.isValid(above) && grid.isEmpty(above)) {
                grid.setIndex(above, new Smoke());
                // Smoke 生成后不影响当前粒子的位置，所以返回 undefined
            }
        }
    }
}
